import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerSokobanTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  SokobanDefinition,
  SokobanProgress,
  SokobanSolution,
  SokobanSubmission,
} from "./types";

registerSokobanTranslations(i18n);

export const sokobanModule: PuzzleTypeModule<
  SokobanDefinition,
  SokobanSubmission,
  SokobanProgress,
  SokobanSolution
> = {
  key: "sokoban",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
